import * as qs from 'qs';

export const isUriToggleOn = (feature: string) => {
  return qs.parse(window.location.search.slice(1))[feature];
};
